import { createSelector } from '@ngrx/store';
import { CategoriesState } from './categories.state';
import { getBuyerState } from '../feature-selector';
import { BuyerState } from '../state';
import { CachedCategoriesUtil } from '~app/modules/generic/utils/cached-categories.util';

export const getCategoriesState = createSelector(
  getBuyerState,
  (state: BuyerState) => {
    return state.categories;
  }
);

export const isCategoriesLoaded = createSelector(
  getCategoriesState,
  (categoryState: CategoriesState) => {
    return categoryState.isLoaded;
  }
);

export const getCategories = createSelector(
  getCategoriesState,
  (categoriesState: CategoriesState) => {
    // We are loading the categories in nodejs app not the state
    // We kept the "store" logic because we wanna make sure that
    // this way is better than the store
    if (CachedCategoriesUtil.isCachedCategoriesExisted()) {
      return CachedCategoriesUtil.getCachedCategories();
    }
    return categoriesState.payload || [];
  }
);

export const isCategoriesLoading = createSelector(
  getCategoriesState,
  (categoriesState: CategoriesState) => {
    return categoriesState.loading;
  }
);
